module.exports = __webpack_public_path__ + "static/media/1001184MF.8a93f816.jpg";